import { AvailabilitySettingsComponent } from 'app/components/availability-settings/AvailabilitySettingsComponent'
import { useAvailabilitySettings } from 'app/components/availability-settings/useAvailabilitySettings'

export default function Settings() {
  const hookData = useAvailabilitySettings()
  return <AvailabilitySettingsComponent {...hookData} />
}
